import init, { push } from '@socialgouv/matomo-next'
import baseLogger from '@/common/services/BaseLogger'

class UserAnalytics {
  track = (args) => {
    try {
      push(args)
    } catch (error) {
      baseLogger.logger.info('track failed')
    }
  }

  trackEvent = (args) => {
    try {
      push(['trackEvent', ...args])
    } catch (error) {
      baseLogger.logger.info('trackEvent failed')
    }
  }

  init = () => {
    try {
      const url = process.env.NEXT_PUBLIC_MATOMO_URL
      const id = process.env.NEXT_PUBLIC_MATOMO_ID

      init({ url: url, siteId: id })
    } catch (error) {
      baseLogger.logger.info('matomo failed')
    }
  }
}

export const userAnalytics = new UserAnalytics()
